/**
 * Trunnion AI - Command Palette Group
 * Renders a titled section of command items within the palette results.
 */

import { CommandItem, type Command } from '@/components/command-palette/CommandItem';

interface CommandGroupProps {
  title: string;
  items: Command[];
  selectedIndex: number;
  startIndex: number;
  onSelect: (cmd: Command) => void;
  onHover: (absoluteIndex: number) => void;
}

export function CommandGroup({
  title,
  items,
  selectedIndex,
  startIndex,
  onSelect,
  onHover,
}: CommandGroupProps) {
  if (items.length === 0) return null;

  return (
    <div className="px-2 py-1.5">
      <p className="mb-1 px-3 text-xs font-semibold uppercase tracking-wider text-trunnion-slate-400">
        {title}
      </p>
      <div role="group" aria-label={title}>
        {items.map((cmd, i) => {
          const absoluteIndex = startIndex + i;
          return (
            <CommandItem
              key={cmd.id}
              command={cmd}
              isSelected={absoluteIndex === selectedIndex}
              onSelect={() => onSelect(cmd)}
              onHover={() => onHover(absoluteIndex)}
            />
          );
        })}
      </div>
    </div>
  );
}
